import scrollIntoViewPolyfill from 'scroll-into-view-if-needed';
import { __assign } from 'tslib';

let id = Date.now(); // TFSID 872587 don't start from 0 because Chrome assumes same-id is same-field

export function generateId(): string {
  return `tab-shared-widget-${id++}`;
}

/** setTimeout around node.focus, with some safety checks */
export function timeoutFocus(node: SVGElement | HTMLElement | null | undefined): void {
  window.setTimeout(() => {
    if (node && window.document.body.contains(node)) {
      node.focus();
    }
  });
}

export function detectScrollbarWidth(): number {
  const div = document.createElement('div');
  div.className = 'scrollbarMeasurement';
  __assign(div.style, {
    width: '100px',
    height: '100px',
    overflowY: 'scroll',
    position: 'absolute',
    visibility: 'hidden',
    border: 'none'
  });
  document.body.appendChild(div);
  const scrollbarWidth = div.offsetWidth - div.clientWidth;

  document.body.removeChild(div);
  return scrollbarWidth;
}

export function isElementOverflownX(element: Element): boolean {
  return element && element.clientWidth < element.scrollWidth;
}

/** IE11-safe substitute for Element.closest */
declare global {
  interface Element {
    msMatchesSelector(selectors: string): boolean;
  }
}
export function closest(element: Element, selector: string): Element | null {
  if (element.closest) { return element.closest(selector); }

  const matches = Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
  if (!matches) { return null; }

  let node: Element | null = element;
  while (node) {
    if (matches.call(node, selector)) {
      return node;
    }
    node = node.parentElement;
  }
  return null;
}

export function scrollIntoView(elem: HTMLElement | null | undefined, block: ScrollLogicalPosition = 'nearest'): void {
  if (!elem) { return; }
  scrollIntoViewPolyfill(elem, { block, behavior: 'auto', scrollMode: 'if-needed' });
}

export function findBlurRelatedTarget(e: React.FocusEvent<HTMLElement>): HTMLElement | null {
  return e.relatedTarget as HTMLElement;
}

// nasty hack to work around Safari bug which dispatches multiple focus events with
// as single click on trackpads: https://github.com/facebook/react/issues/10871
// credit to https://gist.github.com/pmacmillan/5e78836821ac22031567382dadd4a72e
export function shouldIgnoreFocusEvent(e: React.FocusEvent<HTMLInputElement>): boolean {
  // tslint:disable:no-any
  const target: any = e.target;
  // tslint:disable:no-any
  const relatedTarget: any = e.relatedTarget;

  // test if we are ignoring the current event because we recevied another one too soon
  if (target.lastFocusEventMs && e.timeStamp < target.lastFocusEventMs + 100) {
    return true;
  }

  target.lastFocusEventMs = e.timeStamp;
  if (relatedTarget) {
    relatedTarget.lastFocusEventMs = e.timeStamp;
  }

  return false;
}

export function selectInputText(input: HTMLInputElement): void {
  window.setTimeout(() => {
    // Defect 706678: only certain element types support setSelectionRange, but Safari prefers it
    try {
      if (input.value) {
        input.setSelectionRange(0, input.value.length);
      }
    } catch (e) {
      input.select();
    }
  });
}
